import { FBAccountsActionTypes, INewFBAccount, TFBAccountsActions } from './actions';

interface IFBAccountsState {
  newAccounts: INewFBAccount[];
}

const initialState: IFBAccountsState = {
  newAccounts: [],
};

export const fbAccountsReducer = (state = initialState, action: TFBAccountsActions): IFBAccountsState => {
  switch (action.type) {
    case FBAccountsActionTypes.ADD_NEW_ACCOUNT:
      return { ...state, newAccounts: [...state.newAccounts, action.payload] };
    case FBAccountsActionTypes.CHANGE_ACCOUNT:
      return {
        ...state,
        newAccounts: [
          ...state.newAccounts.map((el) => {
            if (el.key === action.payload.key) {
              return { ...action.payload, key: el.key };
            }
            return el;
          }),
        ],
      };
    case FBAccountsActionTypes.REMOVE_NEW_ACCOUNT:
      return {
        ...state,
        newAccounts: [...state.newAccounts.filter((el) => el.accessToken !== action.payload)],
      };
    default:
      return state;
  }
};
